<template>
    <div>
        <vs-card>
            
            <b-button style="background-color: #28C76F; border-color:#28C76F;" v-on:click="stokKoduEslestir()"
                id="loading-eslestir" class="vs-con-loading__container">
                <Icon style="margin-right: 5px" icon="ph:git-merge" width="20" height="20"
                    v-b-tooltip.hover.bottom="'Eşleştir'" />
            </b-button>
        </vs-card>
    </div>
</template>
<script>
export default {
    methods: {
        stokKoduEslestir(kontrol) {
            let type = "radius";

            var vs = this.$vs;
            var vm = this;
            vm.veriler = [];
            vs.loading({
                container: `#loading-eslestir`,
                type
            });
            if (kontrol != 1) {
                if (vm.secilenStok == "" && vm.girilenStok == "") {
                    setTimeout(() => {
                        vs.loading.close("#loading-eslestir > .con-vs-loading");
                    }, 1000);
                    vs.notify({
                        title: "Pazaryeri",
                        text: "Pazaryeri stok bilgisi eksik",
                        iconPack: "feather",
                        icon: "icon-alert-circle",
                        color: "warning",
                        position: "top-center"
                    });
                } else if (vm.secilenXmlStok == "" && vm.girilenstokM == "") {
                    setTimeout(() => {
                        vs.loading.close("#loading-eslestir > .con-vs-loading");
                    }, 1000);
                    vs.notify({
                        title: "Stok Eşleme",
                        text: "Lütfen bütün alanların dolu olduğundan emin olun",
                        iconPack: "feather",
                        icon: "icon-alert-circle",
                        color: "warning",
                        position: "top-center"
                    });
                }
            }
            else {
                const soap = require("soap");
                const url = state.sistemAddress;

                const args = {
                    token: Store.state.tokenId,
                    program: vm.secilenXmlStokFirma,
                    programBarkod:
                        vm.secilenStok.trim() == ""
                            ? vm.girilenStok
                            : vm.secilenStok.trim(),
                    muhasebeBarkod:
                        vm.secilenXmlStok.trim() == ""
                            ? vm.girilenstokM
                            : vm.secilenXmlStok.trim(),
                    barkod: vm.secilenXmlStokb == "" ? "" : vm.secilenXmlStokb.trim()
                };
                soap.createClient(url, function (err, client) {
                    client.pazaryeriStokKoduEsleme(args, function (err, result) {
                        if (result.pazaryeriStokKoduEslemeResult == "-1") {
                            Store.dispatch("logout");
                            //this.$store.dispatch('login', payload)
                        }
                        try {
                            vm.veriler = JSON.parse(result.pazaryeriStokKoduEslemeResult);
                            vm.stokKoduEslemeListesi();
                            vm.getStokList();
                            vm.getXmlStokList();
                            vm.$refs["modal-stokEkle"].hide();
                            vs.loading.close("#loading-eslestir > .con-vs-loading");
                            vs.notify({
                                title: "Stok Eşleme",
                                text: "Stok Eşleme Yapıldı",
                                iconPack: "feather",
                                icon: "icon-alert-circle",
                                color: "success",
                                position: "top-center"
                            });
                        } catch (error) {
                            vs.notify({
                                title: "Stok Eşleme",
                                text: "Stok Eşleme Sıradında Hata Oluştu",
                                iconPack: "feather",
                                icon: "icon-alert-circle",
                                color: "danger",
                                position: "top-center"
                            });
                        }
                    });
                });
            }
        },
    }
}
</script>